import { styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import CloseIcon from "@mui/icons-material/Close";

export const Container = styled("div")((props) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: COLORS.white,
  minHeight: props.minHeight,
  padding: "25px",
  borderRadius: "20px",
  "@media(min-width:320px)": {
    minWidth: "300px",
  },
  "@media(min-width:768px)": {
    minWidth: props.maxWidth === "xs" ? "400px" : props.maxWidth === "sm" ? "450px" : "700px",
  },
  "@media(min-width:1200px)": {
    minWidth: props.maxWidth === "xs" ? "440px" : props.maxWidth === "sm" ? "510px" : props.maxWidth === "xl" ? "1000px" : "800px",
  },
}));

export const ContentContainer = styled("div")({
  marginTop: "0px",
  alignSelf: "center",
  width: "100%",
});

export const StyledBackdrop = styled("div")({
  position: "absolute",
  width: "100%",
  height: "100%",
  backdropFilter: "blur(8px)",
});

export const StyledCloseIcon = styled(CloseIcon)({
  alignSelf: "center",
  color: COLORS.secondary,
  "@media (min-width:320px)": {
    fontSize: "18px",
  },
  "@media (min-width:768px)": {
    fontSize: "20px",
  },
  "@media (min-width:1200px)": {
    fontSize: "23px",
  },
});
